// extracted by mini-css-extract-plugin
export default {"servicesContainer":"list_servicesContainer__1SiKJ","bannerGroup":"list_bannerGroup__HDtwK"};